export function includesNotCaseSensitive(a,b) {
    return a.toLowerCase().includes(b.toLowerCase())
}